var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./namespace_info_dialog.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-890b350e\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./namespace_info_dialog.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/registry_manage/namespace_info_dialog.vue
// module id = 1362
// module chunks = 1